import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import { html } from "../../../../../utils/tw";
import { CarTaxiFront } from "lucide-react";
import { backgrounds } from "polished";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("product-details", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("product-details")
      ) {
        return {
          type: "product-details",
        };
      }
    },

    model: {
      toHTML() {
        let rootElement = this.view?.el || this.getEl();
        if (!rootElement) return "";
        let outerHTML = rootElement.outerHTML;

        let productSlug = this.getAttributes().product;
        if (!productSlug) {
          return outerHTML;
        }
        outerHTML = outerHTML.replace(
          /<!--\s*{%\s*product\s+.*?\s+as\s+product\s*%}\s*-->/,
          `{% product '${productSlug}' as product %}`
        );
        return outerHTML;
      },
      defaults: {
        traits: [
          {
            type: "select",
            label: "Product",
            name: "product",
            options: [],
          },
        ],
        productSlug: "",
        tagname: "div",
        classList: ["product-details"],
        components: html`
          <section class="container mx-auto px-4 mt-4">
            <!-- {% product productSlug as product %} -->
            <div class="flex flex-col md:flex-row gap-4 md:p-4 ">
              <div class="w-full md:w-2/5">
                <div class="swiper productSwiper">
                  <div class="swiper-wrapper  ">
                    <div class="swiper-slide flex justify-center">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <!-- {% comment %} -->
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                        <!-- {% endcomment %} -->
                        <!-- <img
                          src="{% generate_thumbnail product.image_url '500x500/filters:format(webp)' %}"
                          alt="{{ product.name }}"
                          class="w-full h-full object-contain rounded-md"
                        /> -->
                      </div>
                    </div>
                    <!--{% for image in product.images %} -->
                    <div class="swiper-slide ">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <!-- {% comment %} -->
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                        <!-- {% endcomment %} -->

                        <!-- <img
                          src="{% generate_thumbnail image.preview_image_url '500x500/filters:format(webp)' %}"
                          alt="{{ product.name }}"
                          class="w-full h-full object-contain rounded-md"
                        />
                         -->
                      </div>
                    </div>
                    <!-- {% endfor %} -->

                    <!-- {% comment %} -->
                    <div class="swiper-slide ">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div class="rounded-md w-full h-[300px] md:h-[500px]   ">
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md"
                        />
                      </div>
                    </div>
                    <!-- {% endcomment %} -->
                  </div>

                  <div class="swiper-pagination"></div>
                </div>
                <div thumbsSlider="" class="swiper previewSwiper mt-2 ">
                  <div class="swiper-wrapper p-2">
                    <div class="swiper-slide  ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14 rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <!-- {% comment %} -->
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                        <!-- {% endcomment %} -->
                        <!-- <img
                          src="{% generate_thumbnail product.image_url '80x80/filters:format(webp)' %}"
                          alt="{{ product.name }}"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        /> -->
                      </div>
                    </div>
                    <!--{% for image in product.images %} -->

                    <div class="swiper-slide ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14  rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <!-- {% comment %} -->

                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                        <!-- {% endcomment %} -->
                        <!-- <img
                          src="{% generate_thumbnail image.preview_image_url '80x80/filters:format(webp)' %}"
                          alt="{{ product.name }}"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                         -->
                      </div>
                    </div>
                    <!-- {% endfor %} -->

                    <!-- {% comment %} -->
                    <div class="swiper-slide ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14  rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14  rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14  rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                      </div>
                    </div>
                    <div class="swiper-slide ">
                      <div
                        class="md:w-20 md:h-20 w-14 h-14  rounded  shadow-sm overflow-hidden relative ripple-effect cursor-pinter"
                      >
                        <img
                          src="https://via.placeholder.com/150"
                          alt="Product Image"
                          class="w-full h-full object-contain rounded-md shadow-sm"
                        />
                      </div>
                    </div>
                    <!-- {% endcomment %} -->
                  </div>
                </div>
              </div>

              <div class="w-full md:w-3/5">
                <h1 class="text-xl font-bold">
                  <!-- {% comment %} -->
                  WRAPPING PAPER
                  <!-- {% endcomment %} -->
                  <!-- {{ product.name }} -->
                </h1>
                <div class="flex gap-x-2 items-center justify-between">
                  <p
                    id="product-selling-price"
                    class="text-[var(--primary)] font-semibold text-md"
                  >
                    Rs.
                    <!-- {% comment %} -->
                    4000
                    <!-- {% endcomment %} -->
                    <!-- {{ product.selling_price_range }} -->
                  </p>
                  <!-- {% comment %} -->

                  <p
                    id="product-stock"
                    class="w-fit text-sm font-medium p-2 bg-secondary md:mr-20 rounded-lg px-4"
                  >
                    Low on Stock
                  </p>
                  <!-- {% endcomment %} -->

                  <!-- <p id="product-stock" style="width:fit-content;"
            class="text-sm font-medium p-2 bg-secondary md:mr-20 rounded-lg px-4">
      {{ product.stock }}</p> -->
                </div>
                <p>
                  <!-- {% comment %} -->
                  Durable Product Wrapping Paper for Courier Packaging
                  <!-- {% endcomment %} -->
                  <!-- {{ product.short_desc }} -->
                </p>

                <h2 class="mt-4 font-semibold text-md">Product Description</h2>
                <div
                  id="description"
                  class="line-clamp-10 relative overflow-hidden"
                >
                  <!-- {% comment %} -->
                  <p>
                    Our <strong>product wrapping paper</strong> is a reliable
                    and eco-friendly packaging solution designed to protect
                    items during shipping and handling. Made from high-quality
                    materials, this wrapping paper ensures durability, prevents
                    damage, and offers a clean, professional presentation.
                  </p>
                  <ul class="list-disc list-inside mt-4">
                    <li>
                      <strong>Tear-Resistant Material:</strong> Ensures items
                      stay securely wrapped during transit.
                    </li>
                    <li>
                      <strong>Eco-Friendly:</strong> Made from recyclable,
                      biodegradable, or compostable materials.
                    </li>
                    <li>
                      <strong>Lightweight and Flexible:</strong> Easy to wrap
                      around products of various shapes and sizes.
                    </li>
                    <li>
                      <strong>Cushioning Properties:</strong> Provides added
                      protection against scratches and impacts.
                    </li>
                    <li>
                      <strong>Customizable:</strong> Available in plain or
                      printed designs for branding purposes.
                    </li>
                  </ul>
                  <!-- {% endcomment %} -->
                  <!-- <div> {{ product.long_desc|safe }} </div>-->
                </div>

                <button
                  id="toggle-btn"
                  class="text-[var(--primary)] mt-2 cursor-pointer overflow-hidden relative ripple-effect"
                >
                  See More
                </button>
                <div id="attribute-list-container">
                  <!-- {% for _, attribute in product.variant_attribute_values.items %} -->

                  <div class=" mt-4 attribute ">
                    <span class="text-sm font-semibold attribute-type">
                      <!-- {% comment %} -->
                      Color
                      <!-- {% endcomment %} -->
                      <!-- {{ attribute.name|capfirst }} -->
                    </span>
                    <div
                      class="flex gap-2 overflow-y-auto no-scrollbar attribute-values cursor-pointer"
                    >
                      <!-- {% for attribute_value in attribute.values %} -->
                      <!-- {% comment %} -->

                      <input
                        type="radio"
                        id="yellow"
                        name="yellow"
                        value="yellow"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <!-- {% endcomment %} -->

                      <!-- <input
                        type="radio"
                        id="{{ attribute_value.id }}"
                        name="{{ attribute_value.id }}"
                        value="{{ attribute_value.id }}"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      /> -->

                      <!-- {% comment %} -->
                      <label
                        for="yellow"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2 overflow-hidden cursor-pointer relative ripple-effect"
                      >
                        Yellow
                      </label>
                      <!-- {% endcomment %} -->
                      <!--<label
                        for="{{ attribute_value.id }}"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2 overflow-hidden cursor-pointer relative ripple-effect"
                      >
                        {{ attribute_value.name }}
                        </label> -->
                      <!-- {% comment %} -->

                      <input
                        type="radio"
                        id="red"
                        name="red"
                        value="red"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <label
                        for="red"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2"
                        >Red</label
                      >
                      <input
                        type="radio"
                        id="blue"
                        name="blue"
                        value="blue"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <label
                        for="blue"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2"
                        >Blue</label
                      >
                    </div>
                  </div>
                  <div class=" mt-4 attribute">
                    <span class="text-sm font-semibold attribute-type">
                      Size
                    </span>
                    <div
                      class="flex gap-2 overflow-y-auto no-scrollbar attribute-values"
                    >
                      <input
                        type="radio"
                        id="large"
                        name="large"
                        value="large"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <label
                        for="large"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2"
                      >
                        Large
                      </label>

                      <input
                        type="radio"
                        id="extra-large"
                        name="extra-large"
                        value="extra-large"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <label
                        for="extra-large"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2"
                        >Extra Large</label
                      >
                      <input
                        type="radio"
                        id="double-xl"
                        name="double-xl"
                        value="double-xl"
                        style="width:fit-content; aspect-ratio:1/1; min-width:32px; min-height:32px; display:none;"
                        class="border rounded-full  "
                      />
                      <label
                        for="double-xl"
                        class="border border-[var(--primary)] text-[var(--primary)] rounded-lg px-2"
                        >Blue</label
                      >
                      <!-- {% endcomment %} -->
                      <!-- {% endfor %} -->
                    </div>
                  </div>

                  <!-- {% endfor %} -->
                </div>
                <div class="flex flex-col gap-y-4 items-center mt-4">
                  <div class="flex justify-center gap-x-2">
                    <button
                      class="border border-[var(--primary)] w-10 h-8 hover:bg-gray-300 hover:text-white cursor-pointer relative overflow-hidden ripple-effect"
                      id="minus-btn-prod"
                    >
                      -
                    </button>
                    <input
                      id="item-quantity-prod"
                      value="1"
                      class="border border-[var(--primary)] w-12 h-8 text-center "
                      max="{{ product.available_quantity }}"
                    />
                    <button
                      class="border border-[var(--primary)] w-10 h-8 hover:bg-gray-300 hover:text-white cursor-pointer relative overflow-hidden ripple-effect"
                      id="plus-btn-prod"
                    >
                      +
                    </button>
                  </div>
                  <div class="flex justify-center gap-x-4 w-full">
                    <button
                      type="button"
                      id="add_to_cart_btn"
                      class="text-center border border-[var(--primary)] w-full max-w-44 py-2 rounded-lg text-[var(--primary)] font-semibold cursor-pointer"
                    >
                      <span id="add-to-cart-text">Add to cart</span>

                      <div
                        role="status"
                        id="spinner"
                        class="spinner hidden flex justify-center"
                      >
                        <svg
                          aria-hidden="true"
                          class="h-6 w-6 text-gray-200 animate-spin dark:text-gray-600 fill-[var(--primary)]"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      </div>
                    </button>
                    <button
                      id="buy_now_btn"
                      disabled="{{ product.stock }}"
                      class="text-center bg-[var(--primary)] w-full max-w-44 py-2 rounded-lg text-white font-semibold cursor-pointer ripple-effect relative overflow-hidden"
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        `,
        avoidInlineStyle: true,

        script: function () {
          let productSlug = "";
          let variantInfo = "{% get_variant product.slug %}";
          const decodedString = variantInfo.replace(/&#x27;/g, "'");
          const validJSONString = decodedString.replace(/'/g, '"');
          const jsonObject = JSON.parse(validJSONString);
          const inStock: string = "{{ product.available_stock }}";
          const plusBtn = document.getElementById(
            "plus-btn-prod"
          ) as HTMLButtonElement;
          const addToCartBtn = document.getElementById(
            "add_to_cart_btn"
          ) as HTMLButtonElement;
          const buyNowBtn = document.getElementById(
            "buy_now_btn"
          ) as HTMLButtonElement;

          const minusBtn = document.getElementById(
            "minus-btn-prod"
          ) as HTMLButtonElement;
          const quantityInput = document.getElementById(
            "item-quantity-prod"
          ) as HTMLInputElement;

          const description = document.getElementById("description");
          const toggleBtn = document.getElementById("toggle-btn");
          let isExpanded = false;
          description.classList.add("line-clamp-10");

          const checkToggleVisibility = () => {
            const lineHeight = parseFloat(
              window.getComputedStyle(description).lineHeight
            );
            const maxLines = 3;
            const maxHeight = lineHeight * maxLines;

            if (description.scrollHeight <= maxHeight) {
              toggleBtn.style.display = "none";
            } else {
              toggleBtn.style.display = "block";
            }
          };

          // Run check on page load
          checkToggleVisibility();

          toggleBtn.addEventListener("click", () => {
            isExpanded = !isExpanded;
            if (isExpanded) {
              description.classList.remove("line-clamp-10", "overflow-hidden");
              toggleBtn.textContent = "See Less";
            } else {
              description.classList.add("line-clamp-10", "overflow-hidden");
              toggleBtn.textContent = "See More";
            }
          });
          let selectedValues = [];

          const attributeContainers =
            document.querySelectorAll(".attribute-values");

          const disableButtons = () => {
            addToCartBtn.disabled = true;
            buyNowBtn.disabled = true;

            addToCartBtn.classList.add(
              "opacity-50",
              "cursor-not-allowed",
              "border-gray-500",
              "text-gray-500"
            );
            addToCartBtn.classList.remove(
              "border-[var(--primary)]",
              "text-[var(--primary)]",
              "cursor-pointer"
            );

            buyNowBtn.classList.add(
              "opacity-50",
              "cursor-not-allowed",
              "bg-gray-500"
            );
            buyNowBtn.classList.remove("bg-[var(--primary)]", "cursor-pointer");
          };

          const enableButtons = () => {
            addToCartBtn.disabled = false;
            buyNowBtn.disabled = false;

            addToCartBtn.classList.remove(
              "opacity-50",
              "cursor-not-allowed",
              "border-gray-500",
              "text-gray-500"
            );
            addToCartBtn.classList.add(
              "border-[var(--primary)]",
              "text-[var(--primary)]",
              "cursor-pointer"
            );

            buyNowBtn.classList.remove(
              "opacity-50",
              "cursor-not-allowed",
              "bg-gray-500"
            );
            buyNowBtn.classList.add("bg-[var(--primary)]", "cursor-pointer");
          };

          const replaceImages = (images) => {
            const productImages = document.querySelectorAll(
              ".productSwiper .swiper-slide img"
            ) as NodeListOf<HTMLImageElement>;

            const previewImages = document.querySelectorAll(
              ".previewSwiper .swiper-slide img"
            ) as NodeListOf<HTMLImageElement>;

            images.forEach((imageUrl, index) => {
              if (productImages[index]) {
                productImages[index].src = imageUrl;
              }
              if (previewImages[index]) {
                previewImages[index].src = imageUrl;
              }
            });
          };

          const getVariant = function () {
            const slug = "{{ product.slug }}";
            fetch("{% url 'get_variant' %}", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                slug: slug,
                selected_attributes: selectedValues,
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Failed to get variant");
                }
                return response.json();
              })
              .then((result) => {
                if (result) {
                  productSlug = result?.slug;
                  let productSellingPrice = document.querySelector(
                    "#product-selling-price"
                  );
                  let productStock = document.querySelector("#product-stock");
                  productSellingPrice.textContent = result?.price;
                  productStock.textContent = result?.stock;
                  replaceImages(result?.images);
                }
                if (result?.stock_available) {
                  enableButtons();
                } else {
                  disableButtons();
                }
              })
              .catch((error) => {
                console.error("Error fetching variant:", error);
                disableButtons();
              });
          };

          if (attributeContainers && attributeContainers.length !== 0) {
            attributeContainers.forEach((container, index) => {
              const labels = container.querySelectorAll("label");
              labels.forEach((label) => {
                const input = document.getElementById(
                  label.getAttribute("for")
                ) as HTMLInputElement;

                if (Object.keys(jsonObject).length === 0) {
                  return;
                }

                // Check if input value exists in JSON variant attributes
                if (
                  input &&
                  jsonObject?.variant_attributes.includes(input.value)
                ) {
                  input.checked = true;

                  // Reset styles for all labels in the container
                  labels.forEach((lbl) => {
                    lbl.style.backgroundColor = "transparent";
                    lbl.style.color = "var(--primary)";
                  });

                  // Apply styles to selected label
                  label.style.backgroundColor = "var(--primary)";
                  label.style.color = "white";

                  // Store selected value in the correct index
                  selectedValues[index] = input.value;
                }
              });
            });

            // Filter out empty values
            selectedValues = selectedValues.filter(
              (val) => val != null && val !== ""
            );
            getVariant();
          }

          const isVariant = Object.keys(jsonObject).length !== 0;

          if (!isVariant) {
            if (String(inStock) === "True") {
              enableButtons();
            } else {
              disableButtons();
            }
          }

          // Handle attribute selection on click
          attributeContainers.forEach((container, index) => {
            container.addEventListener("click", function (event) {
              const target: any = event.target;

              if (target.tagName === "LABEL") {
                const input = document.getElementById(
                  target.getAttribute("for")
                ) as HTMLInputElement;

                if (input) {
                  input.checked = true;

                  // Reset styles for all labels in the container
                  container.querySelectorAll("label").forEach((label) => {
                    label.style.backgroundColor = "transparent";
                    label.style.color = "var(--primary)";
                  });

                  // Apply styles to selected label
                  target.style.backgroundColor = "var(--primary)";
                  target.style.color = "white";

                  // Update selected value for the corresponding attribute type (replace instead of pushing)
                  selectedValues[index] = input.value;

                  // Ensure selectedValues remains clean (removes empty values)
                  selectedValues = selectedValues.filter(
                    (val) => val != null && val !== ""
                  );

                  getVariant();
                }
              }
            });
          });

          const maxValue =
            parseInt(quantityInput.getAttribute("max"), 10) || 10;
          plusBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value, 10) || 1;
            quantityInput.value = String(Math.min(maxValue, currentValue + 1));
          });

          minusBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value, 10) || 1;
            if (currentValue > 1) {
              quantityInput.value = String(currentValue - 1);
            }
          });

          quantityInput.addEventListener("input", () => {
            if (Number(quantityInput.value) < 1) {
              quantityInput.value = "1";
            } else if (Number(quantityInput.value) > maxValue) {
              quantityInput.value = String(maxValue);
            }
          });

          buyNowBtn.addEventListener("click", () => {
            let count = quantityInput.value;
            let productId = "";
            if (!productSlug) {
              productId = "{{ product.slug }}";
            } else {
              productId = productSlug;
            }

            const url = new URL(window.location.origin + "/checkout/");

            url.searchParams.append("product_slug", productId);
            url.searchParams.append("quantity", count);

            window.location.href = url.toString();
          });

          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          const addToCart = function () {
            const spinner = document.querySelector("#spinner");
            const addToCartText = document.querySelector("#add-to-cart-text");
            addToCartBtn.disabled = true;
            addToCartText.classList.add("hidden");
            spinner.classList.remove("hidden");

            let slug = "";
            if (!productSlug) {
              slug = "{{ product.slug }}";
            } else {
              slug = productSlug;
            }

            const quantity = quantityInput.value;
            fetch("{% url 'add_to_cart' %}", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ slug: slug, quantity: quantity }),
            })
              .then((response) => {
                if (!response.ok) {
                  return response.json().then((errorData) => {
                    showToast(errorData.message, "red");
                    throw new Error(
                      errorData.message || "Something went wrong"
                    );
                  });
                }
                return response.json();
              })
              .then((result) => {
                if (result.cart_count) {
                  const cartElement = document.getElementById("cart-count");
                  if (cartElement) {
                    cartElement.textContent = result.cart_count;
                  }
                }
                showToast(result?.message, "green");
              })
              .catch((error) => {
                console.error("Error adding product to cart:", error);
              })
              .finally(() => {
                addToCartText.classList.remove("hidden");
                spinner.classList.add("hidden");
                addToCartBtn.disabled = false;
              });
          };

          addToCartBtn.addEventListener("click", () => {
            addToCart();
          });

          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".previewSwiper", {
              spaceBetween: 10,
              slidesPerView: 4,
              freeMode: true,
              mousewheel: true,
              watchSlidesProgress: true,
              breakpoints: {
                640: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
              },
            });
            //@ts-ignore
            const swiper2 = new Swiper(".productSwiper", {
              spaceBetween: 10,
              loop: true,
              pagination: {
                el: ".swiper-pagination",
              },
              thumbs: {
                swiper: swiper,
              },
            });
          };

          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }

          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
        styles: `
          .product-details ul {
            margin-top: 1rem;
          }
        `,
      },

      async init() {
        this.loadTraitOptions();
        this.on("change:attributes:productSlug", this.handleTypeChange);
      },
      async loadTraitOptions() {
        const productResponse = await getApiData(APIS.PRODUCT, {});
        this.set({
          traits: [
            {
              type: "select",
              label: "Product",
              name: "product",
              options:
                productResponse?.data?.map((item: any) => ({
                  id: item.slug,
                  name: item.name,
                })) ?? [],
            },
          ],
        });
      },
      handleTypeChange() {
        this.addAttributes({ productSlug: this.getAttributes().product });
        this.loadTraitOptions();
      },
    },
  });
};
